import React from 'react';
import { Col, FormGroup, Row } from 'react-bootstrap';
import { Button, Box, Label } from 'fw/components';
import { Form, CurrencyBox } from 'fw/forms';
import * as Modals from 'fw/globals/Modals'

class CurrencyBoxDemo extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            form: {
                preset: 123456789
            },
            unmanaged: {
                preset: 123456789
            }
        };
    }

    // Managed
    handleChange = (form) => {
        this.setState({ form });
    }

    handleSubmit = () => {
        Modals.alert(JSON.stringify(this.state.form));
    }

    handleUpdateForm = () => {
        const form = {
            ...this.state.form,
            preset: 111,
            required: 222,
            disabled: 333444.55,
            default: 1234.56
        };

        this.setState({ form });
    }

    handleCustomValidationValidate = (value) => {
        if (value > 5000)
            return "Amount cannot be greater than $5,000";
    }

    // Unmanaged
    handleShowUnamagedState = () => {
        Modals.alert(JSON.stringify(this.state.unmanaged));
    }

    handleUpdateUnmanagedState = () => {
        const unmanaged = {
            ...this.state.unmanaged,
            preset: 111,
            required: 222,
            disabled: 333444.55,
            default: 1234.56
        };

        this.setState({ unmanaged });
    }

    handleUnmanagedDefaultChange = (value, display) => {
        const unmanaged = { ...this.state.unmanaged, default: value };
        this.setState({ unmanaged });
    }

    handleUnmanagedPlaceholderChange = (value, display) => {
        const unmanaged = { ...this.state.unmanaged, placeholder: value };
        this.setState({ unmanaged });
    }

    handleUnmanagedDisabledChange = (value, display) => {
        const unmanaged = { ...this.state.unmanaged, disabled: value };
        this.setState({ unmanaged });
    }

    handleUnmanagedPresethange = (value, display) => {
        const unmanaged = { ...this.state.unmanaged, preset: value };
        this.setState({ unmanaged });
    }

    handleUnmanagedRequiredChange = (value, display) => {
        const unmanaged = { ...this.state.unmanaged, required: value };
        this.setState({ unmanaged });
    }

    handleUnmanagedPositiveOnlyChange = (value, display) => {
        const unmanaged = { ...this.state.unmanaged, positiveOnly: value };
        this.setState({ unmanaged });
    }

    render() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={6}>
                        <Box title="CurrencyBox">
                            <Form
                                onChange={this.handleChange}
                                values={this.state.form}
                                onSubmit={this.handleSubmit}>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label>Default</Label>
                                            <CurrencyBox name="default" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label>Placeholder</Label>
                                            <CurrencyBox name="placeholder" placeholder="Total amount" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label>Disabled</Label>
                                            <CurrencyBox name="disabled" disabled />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label>Preset</Label>
                                            <CurrencyBox name="preset" />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label required>Required</Label>
                                            <CurrencyBox name="required" required />
                                        </FormGroup>
                                    </Col>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label>Positive Only</Label>
                                            <CurrencyBox name="positiveOnly" positiveNumbersOnly />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col md={4}>
                                        <FormGroup>
                                            <Label required>Validation (&lt; 5000)</Label>
                                            <CurrencyBox name="customValidation" onValidate={this.handleCustomValidationValidate} required />
                                        </FormGroup>
                                    </Col>
                                </Row>
                                <hr />
                                <div className="btn-toolbar">
                                    <Button id="btnUpdateForm" className="pull-left" onClick={this.handleUpdateForm}>Update Form</Button>
                                    <Button id="btnSubmit" type="submit" className="pull-right">Submit</Button>
                                </div>
                            </Form>
                        </Box>
                    </Col>
                    <Col md={6}>
                        <Box title="CurrencyBox / Unmanaged">
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Unmanaged - Default</Label>
                                        <CurrencyBox value={this.state.unmanaged.default} onChange={this.handleUnmanagedDefaultChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Unmanaged - Placeholder</Label>
                                        <CurrencyBox value={this.state.unmanaged.placeholder} onChange={this.handleUnmanagedPlaceholderChange} placeholder="Total amount" />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Unmanaged - Disabled</Label>
                                        <CurrencyBox value={this.state.unmanaged.disabled} onChange={this.handleUnmanagedDisabledChange} disabled />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Unmanaged - Preset</Label>
                                        <CurrencyBox value={this.state.unmanaged.preset} onChange={this.handleUnmanagedPresetChange} />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label required>Unmanaged - Required</Label>
                                        <CurrencyBox value={this.state.unmanaged.required} onChange={this.handleUnmanagedRequiredChange} required />
                                    </FormGroup>
                                </Col>
                                <Col md={4}>
                                    <FormGroup>
                                        <Label>Unmanaged - Positive Only</Label>
                                        <CurrencyBox value={this.state.unmanaged.positiveOnly} onChange={this.handleUnmanagedPositiveOnlyChange} positiveNumbersOnly />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <hr />
                            <div className="btn-toolbar">
                                <Button id="btnUpdateUnmanagedState" className="pull-left" onClick={this.handleUpdateUnmanagedState}>Update Unmanaged State</Button>
                                <Button id="btnShowUnmanagedState" className="pull-right" onClick={this.handleShowUnamagedState}>Show Unmanaged State</Button>
                            </div>
                        </Box>
                    </Col>
                </Row>
            </React.Fragment>
        )
    }
}

export default CurrencyBoxDemo;



// WEBPACK FOOTER //
// ./src/areas/demo/primeroDemo/BasicInputs/CurrencyBoxDemo.js